var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg073RightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 13H18.59L13.29 18.29C13.1007 18.4778 12.9942 18.7334 12.9942 19C12.9942 19.2667 13.1007 19.5223 13.29 19.71C13.4778 19.8993 13.7334 20.0058 14 20.0058C14.2666 20.0058 14.5222 19.8993 14.71 19.71L21.71 12.71C21.8993 12.5223 22.0058 12.2667 22.0058 12C22.0058 11.7334 21.8993 11.4778 21.71 11.29L14.71 4.29003C14.4563 4.03637 14.0866 3.9373 13.7401 4.03015C13.3936 4.12299 13.123 4.39364 13.0301 4.74015C12.9373 5.08665 13.0363 5.45637 13.29 5.71003L18.59 11H3C2.44772 11 2 11.4477 2 12C2 12.5523 2.44772 13 3 13Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg073RightArrow);
export default __webpack_public_path__ + "static/media/073-right-arrow.164084463a6a9e5003be6d8052eedb88.svg";
export { ForwardRef as ReactComponent };